import styled from "styled-components";
import GrnDetailsModals from "./GrnDetailsModals";
import { Button, Details, FlexColumn, SeparatorLine, WhiteWrapper, RaiseDisputeOutlineButton } from "../Common/styles.common";
import ProductImageCard from "components/shared/Card/ProductImageCard";
import React from "react";
import SafeHtml from "components/shared/helpers/SafeHtml";
import { Loader } from "../Common/Loader";
import { GrnSummaryCard, GrnDetailsHeaderTag, GrnSummaryMetric, GrnSummaryMetrics, GrnSummarySectionWrapper, GrnInfoLabelWrapper, GrnItemCardWrapper, ItemQtyBox, ItemQtyDivider, ProductThumb, GrnPageWrapper, DisputeClaimText, DisputeClaimFooter, DisputeClaimInlineShade } from "./styles.grn";
import InfoBanner from "components/shared/Label/InfoLabel";
import GrnDetailsSummaryTable from "./GrnDetailsSummary/GrnDetailsSummaryTable";
import { strings } from "utils/constants/strings";
import { GRN_DISPUTE_ISSUE_TYPE } from "utils/constants/others";
import BackButton from "../Button/BackButton";
import getHexColor from "utils/getHexColor";

// Fixed full-screen layout: anchor to the viewport so it covers the app header BasePageView renders above mobile views.
const MobilePageWrapper = styled(GrnPageWrapper)`
  top: 0;
  left: 0;
`;

const GrnDetailsMobile = (props) => {
 const {
 source, grnId, purchaseOrderId, grn, grnItems, showLoader, navigate, isDisputeAllowed, itemDisputeMap, isInDispute, grnSummary, grnDetailsHeaderTag, totalGrnWeight, toggleDiscrepancyModal, handleConfirmGrn,
 } = props;

  const grnItemCards = grnItems.map((item) => {
    const itemClaims = itemDisputeMap[item?.id] ?? {};
    const priceClaimedValue = itemClaims[GRN_DISPUTE_ISSUE_TYPE.PRICE_PER_UNIT];
    const gstClaimedValue = itemClaims[GRN_DISPUTE_ISSUE_TYPE.GST_PERCENTAGE];
    const qtyClaimedValue = itemClaims[GRN_DISPUTE_ISSUE_TYPE.GRN_QUANTITY];

    const rightDiv = isInDispute && (priceClaimedValue || gstClaimedValue) ? (
      <DisputeClaimInlineShade>
        {priceClaimedValue && (
          <DisputeClaimText>
            Your claim: &#8377;{priceClaimedValue} / {item.buy_measurement_unit}
          </DisputeClaimText>
        )}
        {gstClaimedValue && (
          <DisputeClaimText>
            Your GST claim: {gstClaimedValue}%
          </DisputeClaimText>
        )}
      </DisputeClaimInlineShade>
    ) : null;

    const innerDiv = (
      <>
        <ItemQtyBox>
          <FlexColumn className="wd-50 align-items-center">
            <span className="fs-15 fw-700">{item?.invoiced_quantity} {item?.buy_measurement_unit}</span>
            <span className="fs-13 fw-400 text-gray-cool mt-1">{strings.invoicedQty}</span>
          </FlexColumn>
          <ItemQtyDivider />
          <FlexColumn className="wd-50 align-items-center">
            <span className="fs-15 fw-700">{item?.grn_quantity} {item?.buy_measurement_unit}</span>
            <span className="fs-13 fw-400 text-gray-cool mt-1">{strings.grnQty}</span>
          </FlexColumn>
        </ItemQtyBox>
        {item.discrepancy_qty_reasons?.length ? (
          <span className="fs-12 fw-500 text-red-500 mt-3" onClick={() => toggleDiscrepancyModal(item)}>
            {strings.discrepancyReasons}
          </span>
        ) : <></>}
      </>
    );

    const footerDiv = isInDispute && qtyClaimedValue ? (
      <DisputeClaimFooter>
        <DisputeClaimText>
          Your claimed quantity: {qtyClaimedValue} {item.buy_measurement_unit}
        </DisputeClaimText>
      </DisputeClaimFooter>
    ) : null;

    return (
      <GrnItemCardWrapper key={item?.id ?? item?.purchase_order_item_id}>
        <ProductImageCard
          imageComponent={<ProductThumb src={item?.product_image} alt={item?.product_name} />}
          title={item?.product_name}
          subtitle={`₹${item?.grn_price_per_unit}/${item?.buy_measurement_unit}`}
          rightDiv={rightDiv}
          innerDiv={innerDiv}
          footerDiv={footerDiv}
        />
      </GrnItemCardWrapper>
    );
  });

  return (
  <React.Fragment>
      {showLoader ? (
        <Loader />
      ) : (
        <MobilePageWrapper className="d-flex flex-column">
          <div className="d-flex flex-column y-scroll">
            <Details $noPaddingBottom={!!grnDetailsHeaderTag?.text}>
              <div className="d-flex align-items-center ml-4">
                <BackButton
                  pathName={source === "all" ? "/po/list" : "/grn/list"}
                />
                <div className="d-flex flex-column ml-1 mr-4">
                  <span className="fs-14 fw-700">{grn?.grn_number}</span>
                  <span className="fs-12 fw-400 text-gray-cool mt-1">
                    {grnItems.length} SKU{grnItems.length > 1 ? "s" : ""} {
                      grnItems.length > 0 ?
                        `• ${totalGrnWeight} kg` : <></>
                    }
                  </span>
                </div>
              </div>
              <SeparatorLine />
              {grnDetailsHeaderTag?.text ? (
                <GrnDetailsHeaderTag
                  $background={getHexColor(grnDetailsHeaderTag?.bg_color)}
                  $text_color={getHexColor(grnDetailsHeaderTag?.color)}
                >
                  <span className="fs-14 fw-600">{grnDetailsHeaderTag.text}</span>
                </GrnDetailsHeaderTag>
              ) : null}
            </Details>
            {grnSummary?.info_label?.text && (() => {
              const infoLabel = grnSummary.info_label;
              const textColor = getHexColor(infoLabel?.color);
              const bgColor = getHexColor(infoLabel?.bg_color);
              const fontWeight = "400";
              const fontSize = "14px";
              return (
                <GrnInfoLabelWrapper>
                  <InfoBanner
                    icon={infoLabel?.text.includes("resolved") ? "/logos/order-history.svg" : "/logos/exclamation-line.svg"}
                    iconSize={infoLabel?.text.includes("resolved") ? 16 : 20}
                    $bg={bgColor}
                    $color={textColor}
                    $fontSize={fontSize}
                    $fontWeight={fontWeight}
                  >
                    <SafeHtml
                      tag="span"
                      style={{ color: textColor, lineHeight: "1.5", fontSize, fontWeight }}
                      html={infoLabel.text}
                    />
                  </InfoBanner>
                </GrnInfoLabelWrapper>
              );
            })()}
            {grnSummary && (
              <GrnSummarySectionWrapper>
                <GrnSummaryCard>
                  <GrnSummaryMetrics>
                    <GrnSummaryMetric>
                      <span className="fs-18 fw-600">
                        {grnSummary?.invoice_amount?.value}
                      </span>
                      <span className="fs-13 fw-400 text-gray-cool">
                        {grnSummary?.invoice_amount?.label}
                      </span>
                    </GrnSummaryMetric>
                    <GrnSummaryMetric>
                      <span className="fs-18 fw-600">
                        {grnSummary?.grn_amount?.value}
                      </span>
                      <span className="fs-13 fw-400 text-gray-cool">
                        {grnSummary?.grn_amount?.label}
                      </span>
                    </GrnSummaryMetric>
                  </GrnSummaryMetrics>
                  <GrnDetailsSummaryTable rows={grnSummary?.rows} />
                </GrnSummaryCard>
              </GrnSummarySectionWrapper>
            )}
            <>
              <div style={{ padding: "16px" }}>
                <span style={{
                  color: "var(--color-base-grey-900, #293142)",
                  fontSize: "20px",
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: "26px",
                  letterSpacing: "-0.2px",
                }}>
                  {strings.grnDetails}
                </span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px", padding: "0 16px 16px 16px" }}>
                {grnItemCards}
              </div>
            </>

          </div>

          {grn?.grn_page_data?.can_confirm_grn ? (
            <WhiteWrapper className="px-5">
              {isDisputeAllowed ? (
                <div className="d-flex" style={{ columnGap: '12px' }}>
                  <RaiseDisputeOutlineButton
                    onClick={() => navigate(`/grn/dispute/${source}/${purchaseOrderId}/${grnId}`)}
                  >
                    {strings.grnMobileRaiseDispute}
                  </RaiseDisputeOutlineButton>
                  <Button
                    className="fs-16 text-white fw-600"
                    style={{ flex: 1 }}
                    onClick={handleConfirmGrn}
                  >
                    {strings.grnMobileConfirmGrn}
                  </Button>
                </div>
              ) : (
                <Button
                  className="fs-16 text-white fw-600"
                  style={{ width: "100%" }}
                  onClick={handleConfirmGrn}
                >
                  {strings.grnMobileConfirmGrn}
                </Button>
              )}
            </WhiteWrapper>
          ) : (
            <></>
          )}
        </MobilePageWrapper>
      )}
   <GrnDetailsModals {...props} />
  </React.Fragment>
 );
};

export default GrnDetailsMobile;
